import React, { useContext } from 'react'

import { Input, Modal, Form, Upload, Select} from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { displayMessage } from '../../services/helper';
import { InboxOutlined } from '@ant-design/icons';
import ELanguages from '../../enums/ELanguages';
const { Dragger } = Upload;

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function CreateExercise(props) {
    const [form] = Form.useForm()
    const movieUrl = Form.useWatch('movieUrl', form)
    const openingVideo = Form.useWatch('openingVideo', form);
    const replayVideo = Form.useWatch('replayVideo', form);
    const intervalVideo = Form.useWatch('intervalVideo', form);
    const closingVideo = Form.useWatch('closingVideo', form);
    const audio = Form.useWatch('audio', form);

    const {setShowLoading, user, windowHeight} = useContext(GeneralContext)
    const {Option} = Select;
    const handleCreateExercise = (values) => {
      const MAX_MB = 2000; //2gb
      const FILE_SIZE_LIMIT = MAX_MB * 1024 * 1024;
        setShowLoading(true)
        try {
            
            const fileObj = {
                // movieUrl: values.movieUrl?.file?.originFileObj,
                openingVideo: values.openingVideo?.file?.originFileObj,
                replayVideo: values.replayVideo?.file?.originFileObj,
                intervalVideo: values.intervalVideo?.file?.originFileObj,
                closingVideo: values.closingVideo?.file?.originFileObj,
                audio: values.audio?.file?.originFileObj
              };
              for (const [key, file] of Object.entries(fileObj)) {
                if (file && file.size > FILE_SIZE_LIMIT) {
                    alert(displayMessage('FILE_SIZE_LIMIT_EXCEEDED', [key, "2gb"]), 'warning');
                    setShowLoading(false);
                    return;
                }
            }
            const formDataBody = new FormData()
            Object.entries(fileObj).forEach(([key, file]) => {
                  if (file) {
                  formDataBody.append(key, file);
                }
              });
            formDataBody.append('name', values.name);
            formDataBody.append('description', values?.description ?? '');
            formDataBody.append('videoRepeatCount',values?.videoRepeatCount)
            formDataBody.append('language', values?.language ?? ELanguages.PORTUGUESE.code)
              
            api.exercise.create(formDataBody).then(
                rs => {
                    alert(displayMessage('CREATE_EXERCISE_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshPatients()
                    setShowLoading(false)
                    props.handleOnCloseModal()
                },
                err => {
                    setShowLoading(false)
                }
            )
            
        } catch (error) {
            console.log(error)
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_EXERCISE')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <Form
                form={form}
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleCreateExercise}
                layout="vertical"
                requiredMark='optional'
            >
                <div className='font-bold text-lg text-appian-blue text-center'>
                    {displayMessage('EXERCISE_DATA')}
                </div>

                <Form.Item
                    label={displayMessage('NAME')}
                    name="name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('NAME_MANDATORY') },
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('DESCRIPTION')}
                    name="description"
                    className={`w-full flex`}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('DESCRIPTION')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
  label={displayMessage('LANGUAGE')}
  name="language"
  className="w-full flex"
  rules={[
    { required: true, message: displayMessage('LANGUAGE_MANDATORY') },
  ]}
>
  <Select
    placeholder={displayMessage('LANGUAGE')}
    size="large"
    className={inputsClassName}
    allowClear
  >
    {Object.values(ELanguages).map((type) => (
      <Option key={type.code} value={type.code}>
        {type.description}
      </Option>
    ))}
  </Select>
</Form.Item>

                <Form.Item
                    label={displayMessage('VIDEO_REPEAT_COUNT')}
                    name="videoRepeatCount"
                    className={`w-full flex`}
                    rules={[
                      { required: true, message: displayMessage('VIDEO_REPEAT_COUNT_MANDATORY') },
                  ]}
                >
                    <Input
                        type="number"
                        min={0}
                        size='large'
                        placeholder={displayMessage('VIDEO_REPEAT_COUNT')}
                        className={inputsClassName}

                    />
                </Form.Item>
                {/* <Form.Item
                    label={displayMessage('ATTACHMENT')}
                    name="movieUrl"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                >
                    <Dragger
                        name="file"
                        multiple={false}
                        beforeUpload={()=>{return null}}
                        accept="video/*,image/*"
                        showUploadList={false}
                        className="!bg-white border border-appian-blue p-4"
                    >
                        <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                        <p className="ant-upload-text">{displayMessage('CLICK_OR_DRAG_FILE')}</p>
                        <p className="ant-upload-hint">{movieUrl?.file?.name || displayMessage('NO_FILE_SELECTED')}</p>
                    </Dragger>
                </Form.Item> */}
                <Form.Item
          label={displayMessage("OPENING_VIDEO")}
          name="openingVideo"
          className={`w-full flex`}
          rules={[
            {
              required: true,
              message: displayMessage("OPENING_VIDEO_MANDATORY"),
            },
          ]}
        >
          <Dragger
            name="file"
            multiple={false}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
  {openingVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
</p>
          </Dragger>
        </Form.Item>
        <Form.Item
          label={displayMessage("REPLAY_VIDEO")}
          name="replayVideo"
          className={`w-full flex`}
          rules={[
            {
              required: true,
              message: displayMessage("REPLAY_VIDEO_MANDATORY"),
            },
          ]}
        >
          <Dragger
            name="file"
            multiple={false}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
  {replayVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
</p>
          </Dragger>
        </Form.Item>
        <Form.Item
          label={displayMessage("INTERVAL_VIDEO")}
          name="intervalVideo"
          rules={[
            {
              required: true,
              message: displayMessage("INTERVAL_VIDEO_MANDATORY"),
            },
          ]}
        >
           <Dragger
            name="file"
            multiple={false}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {intervalVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item label={displayMessage("CLOSING_VIDEO")} 
        name="closingVideo"
        rules={[
          {
            required: true,
            message: displayMessage("CLOSING_VIDEO_MANDATORY"),
          },
        ]}
        >
        <Dragger
            name="file"
            multiple={false}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {closingVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item label={displayMessage("AUDIO")} 
        name="audio"
        rules={[
          {
            required: true,
            message: displayMessage("AUDIO_MANDATORY"),
          },
        ]}
        >      
        <Dragger
            name="file"
            multiple={false}
            beforeUpload={() => {
              return null;
            }}
            accept="audio/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {audio?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_EXERCISE')}
                </SL_Button>
            </Form>
        </Modal >
    )
}